/** The chat-result A/B/C test (composables/useChatResultExperiment.ts, /admin/result-test). */
export const CHAT_RESULT_EXPERIMENT = 'chat_result_v1'
export const CHAT_RESULT_VARIANTS = ['a', 'b', 'c'] as const
export type ChatResultVariant = typeof CHAT_RESULT_VARIANTS[number]
